import { Card } from '@faceup/ui'
import { Suspense } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../../../__generated__'
import { ReportChat, ReportChatPreview } from '../../../../Components/ReportChat'
import { ReportSummary } from '../../../../Components/ReportSummary/ReportSummary'
import { ReportSummaryPreview } from '../../../../Components/ReportSummary/ReportSummaryPreview'
import { SentContent } from '../../../../Components/SentContent/SentContent'
import { isAkutanPreview } from '../../../../utils/urls'
import { useAutoVictimLogin } from '../../hooks/useAutoVictimLogin'
import { useReportSentData } from '../../hooks/useReportSentData'
import { PinForm } from './components'

const fragments = {
  ReportSentGeneral_publicReportSource: graphql(`
    fragment ReportSentGeneral_publicReportSource on PublicReportSource {
      id
      sourceType

      ...useReportSentData_publicReportSource
      ...PinForm_publicReportSource
    }
  `),
}

type ReportSentGeneralProps = {
  reportSource: FragmentType<typeof fragments.ReportSentGeneral_publicReportSource>
}

export const ReportSentGeneral = ({ reportSource: _reportSource }: ReportSentGeneralProps) => {
  const reportSource = getFragmentData(
    fragments.ReportSentGeneral_publicReportSource,
    _reportSource
  )
  const { reportSentDescription } = useReportSentData(reportSource)
  const { isLoggedIn } = useAutoVictimLogin()
  const isPreview = isAkutanPreview()

  return (
    <SentContent sourceType={reportSource.sourceType} description={reportSentDescription}>
      <PinForm reportSource={reportSource} isLoggedIn={isLoggedIn} />
      {isPreview ? (
        <>
          <ReportSummaryPreview />
          <ReportChatPreview />
        </>
      ) : (
        <>
          {isLoggedIn ? <ReportSummary /> : <Card loading className='w-full p-8' />}
          <Suspense fallback={<Card loading className='w-full p-8' />}>
            <ReportChat isLoggedIn={isLoggedIn} />
          </Suspense>
        </>
      )}
    </SentContent>
  )
}
